var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreaterThanEqual(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9543 9.392V10.532L9.05034 12.488V11.36L13.4303 9.968L9.05034 8.576V7.46L14.9543 9.392ZM9.05034 12.944H14.9543V14H9.05034V12.944Z",
    fill: "#1D6295"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 19,
    rx: 2.5,
    stroke: "#1D6295"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreaterThanEqual);
export default __webpack_public_path__ + "static/media/greater_than_equal.c60c3ffcf51a4e2d86a7fb9136fb0edc.svg";
export { ForwardRef as ReactComponent };